import Vue from 'vue'

//---------------------------------------------------------------------------
// Navbar
//---------------------------------------------------------------------------
import { Lang } from 'laravel-vue-lang';
import Cookies from 'vue-cookies';
// it gets the cookie called `username`
// const username = this.$cookies.get("username");
// console.log(username);
// Register the plugin
let lang = Cookies.get("lang");
Vue.use(Lang, {
	locale: lang,
	fallback: 'en',
	ignore: {
		lang: ['validation'],
	},
});

Vue.component('navbar', () => import('./components/partials/navbar.vue'));
const header = new Vue({
    el: '#header'
});
